module.exports = __webpack_public_path__ + "img/EmbolizationCalculation1.bd81a160.png";